var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileWithPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.43 37L60.4537 73.5H20.5463L0.569985 37L20.5463 0.5L60.4537 0.500002L80.43 37Z",
    stroke: "#29A4CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51.1667C47.824 51.1667 54.1666 44.8241 54.1666 37C54.1666 29.176 47.824 22.8334 40 22.8334C32.1759 22.8334 25.8333 29.176 25.8333 37C25.8333 44.8241 32.1759 51.1667 40 51.1667Z",
    stroke: "#29A4CC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31.3334V42.6667",
    stroke: "#29A4CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3333 37H45.6666",
    stroke: "#29A4CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileWithPlus);
export default __webpack_public_path__ + "static/media/tileWithPlus.4d225f9d29471ce778a7276d01f46595.svg";
export { ForwardRef as ReactComponent };